var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C12 3.55228 12.4477 4 13 4L18 4C18.5523 4 19 4.44772 19 5L19 19C19 19.5523 18.5523 20 18 20L13 20C12.4477 20 12 20.4477 12 21C12 21.5523 12.4477 22 13 22L18 22C19.6569 22 21 20.6569 21 19L21 5C21 3.34315 19.6569 2 18 2L13 2C12.4477 2 12 2.44772 12 3Z",
    fill: "#181A1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12C4 12.5523 4.44771 13 5 13L10.865 13L8.89844 15.3598C8.54488 15.7841 8.6022 16.4147 9.02648 16.7682C9.45076 17.1218 10.0813 17.0645 10.4349 16.6402L13.7682 12.6402C14.0773 12.2694 14.0773 11.7307 13.7682 11.3598L10.4349 7.35984C10.0813 6.93556 9.45076 6.87824 9.02648 7.2318C8.60221 7.58537 8.54488 8.21593 8.89845 8.64021L10.865 11L5 11C4.44772 11 4 11.4477 4 12Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.db01ded9ce01e40d17d398c13e0e4aa9.svg";
export { ForwardRef as ReactComponent };